import { ReduceStore } from "flux/utils";
import { List } from "immutable";
import AppDispatcher from "../AppDispatcher";
import RoleStore from "./RoleStore";
import MembershipStore from "./MembershipStore";
import CurrentUserIdStore from "./CurrentUserIdStore";
import OrganizationStore, { Organization } from "./OrganizationStore";

class MembershipDetailsForCurrentUserStore extends ReduceStore {
  getInitialState() {
    return List();
  }

  reduce(state) {
    this.getDispatcher().waitFor([
      CurrentUserIdStore.getDispatchToken(),
      MembershipStore.getDispatchToken(),
      OrganizationStore.getDispatchToken(),
      RoleStore.getDispatchToken(),
    ]);

    if (
      CurrentUserIdStore.hasChanged() ||
      MembershipStore.hasChanged() ||
      OrganizationStore.hasChanged() ||
      RoleStore.hasChanged()
    ) {
      const memberships = MembershipStore.getMembershipsByUser(
        CurrentUserIdStore.getState()
      );
      return memberships.map((m) => ({
        organization: OrganizationStore.get(m.organizationId),
        role: RoleStore.get(m.role),
      }));
    }

    return state;
  }

  /**
   * Return organizations available to this user to login. (Hides virtual orgs)
   * @return {List<Organization>}
   */
  availableLoginOrganizations() {
    return this.getState()
      .map((m) => m.organization)
      .filterNot((o) => o.name.startsWith("-"));
  }
}

const instance = new MembershipDetailsForCurrentUserStore(AppDispatcher);
export default instance;
